import {useMemo} from "react";

import {getPropertyGalleryImages, getPropertyGalleryImageUrlsFromImages, IPropertyGalleryImagesSource} from "../utils/get_property_gallery_images";

export const usePropertyGalleryImages = (property: IPropertyGalleryImagesSource) => {
    const images = useMemo(() => getPropertyGalleryImages(property), [property]);
    const urls = useMemo(() => getPropertyGalleryImageUrlsFromImages(images), [images]);

    return {images, urls};
};
import {useMemo} from "react";

import {getPropertyGalleryImages, getPropertyGalleryImageUrlsFromImages, IPropertyGalleryImagesSource} from "../utils/get_property_gallery_images";

export const usePropertyGalleryImages = (property: IPropertyGalleryImagesSource) => {
    const images = useMemo(() => getPropertyGalleryImages(property), [property]);
    const urls = useMemo(() => getPropertyGalleryImageUrlsFromImages(images), [images]);

    return {images, urls};
};
